<template>
	<div v-if="show">
		<div class="modal-mask">
			<div class="modal-wrapper">
				<div class="modal-dialog" :class="sizeClass" role="document" :data-cy="cypressId">
					<div class="modal-content">
						<div class="modal-header" v-if="title">
							<h5 class="modal-title">{{ title }}</h5>
							<!--
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true"  @click="closeDialog">&times;</span>
							</button>
							-->
						</div>
						<div class="modal-body">
							<div v-if="htmlContent" v-html="htmlContent"></div>
							<p v-else-if="content" class="mb-0">{{ content }}</p>
							<template v-if="prompt">
								<textarea
									class="form-control"
									v-model="userInput"
									:placeholder="prompt"
									v-if="multilinePrompt"
									id="dialog-prompt"
								></textarea>
								<input
									class="form-control"
									v-model="userInput"
									:placeholder="prompt"
									v-else
									id="dialog-prompt"
								/>
							</template>
						</div>
						<div class="modal-footer">
							<button
								type="button"
								class="btn btn-secondary"
								@click="cancel"
								v-if="cancelBtn"
							>
								{{ cancelBtnText }}
							</button>
							<button
								v-if="confirmBtn"
								type="button"
								class="btn btn-primary"
								@click="confirm"
								ref="dialogconfirm"
							>
								{{ confirmBtnText }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			userInput: null,
		};
	},

	props: {},

	mounted() {
	},

	methods: {
		confirm() {
			if (typeof this.confirmCallBack === "function") {
				this.confirmCallBack(this.userInput);
			}
			this.closeDialog();
		},
		cancel() {
			if (typeof this.cancelCallBack === "function") {
				this.cancelCallBack(this.userInput);
			}
			this.closeDialog();
		},
		closeDialog() {
			this.userInput = null;
			this.$store.commit("closeDialog");
		},
	},
	watch: {
		show() {
			if(this.show){
				this.$nextTick(function() {
				if('dialogconfirm' in this.$refs){
					this.$refs.dialogconfirm.focus();
				}
				});
				if (this.defaultUserInput) {
					this.userInput = this.defaultUserInput;
				}
			}
		},
	},
	computed: {
		show() {
			return this.$store.state.dialogSettings.show;
		},
		title() {
			return this.$store.state.dialogSettings.title;
		},
		content() {
			return this.$store.state.dialogSettings.content;
		},
		htmlContent() {
			return this.$store.state.dialogSettings.htmlContent;
		},
		prompt() {
			return this.$store.state.dialogSettings.prompt;
		},
		multilinePrompt() {
			return this.$store.state.dialogSettings.multilinePrompt;
		},
		cancelBtn() {
			return this.$store.state.dialogSettings.cancelBtn;
		},
		confirmBtn() {
			return this.$store.state.dialogSettings.confirmBtn;
		},
		confirmBtnText() {
			return this.$store.state.dialogSettings.confirmBtnText
				? this.$store.state.dialogSettings.confirmBtnText
				: this.$t("ok");
		},
		cancelBtnText() {
			return this.$store.state.dialogSettings.cancelBtnText
				? this.$store.state.dialogSettings.cancelBtnText
				: this.$t("cancel");
		},
		confirmCallBack() {
			return this.$store.state.dialogSettings.confirmCallBack;
		},
		cancelCallBack() {
			return this.$store.state.dialogSettings.cancelCallBack;
		},
		sizeClass() {
			return this.$store.state.dialogSettings.size
				? `modal-${this.$store.state.dialogSettings.size}`
				: "";
		},
		defaultUserInput() {
			return this.$store.state.dialogSettings.defaultUserInput;
		},
		cypressId() {
			return this.$store.state.dialogSettings.cypressId;
		},
	},
};
</script>
